<template lang="pug">
  transition(name="dialog" v-if="active")
    .confirm-dialog.modal.is-active
      .modal-background
      .modal-content: .box
        p {{message}}
        .buttons.is-centered
          .button.is-primary(@click='accept()') Igen
          .button(@click='cancel()') Nem
      .modal-close(@click='cancel()')
  
</template>

<script>

import Vue from 'vue';

export default {
  data: () => ({
    active: false,
    message: ""
  }),
  name: "ConfirmDialog",
  created() {
    Vue.prototype.$confirm = this.show.bind(this);
  },
  methods: {
    show: function(message)
    {
      this.active = true
      this.message = message;
      
      return new Promise((resolve, reject) => {
        this.promise = {resolve, reject}
      });
    },
    cancel: function ()
    {
      this.active = false
      this.promise.reject(false)
    },
    accept: function ()
    {
      this.active = false;
      this.promise.resolve(true)
    },

  },

}
</script>

<style lang='sass' scoped>
.confirm-dialog
  transition: all .3s
  &.dialog-leave-to
    opacity: 0
  
.modal-content
  transition: all .3s 
  .dialog-enter &
    transform: translateY(100px)
    opacity: .3
  
</style>
